export default __webpack_public_path__ + "static/media/E5URhUDU.jpeg.ef1ae139.jpg";